import React from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from 'common/helmets/Helmet';

const Title = 'Akiflow Case Study | Canny';
const Description =
  'How Akiflow organized their feedback and started winning back churned customers';
const Image = 'https://canny.io/images/5a122a7ae6cf1719a5fd5b4d7cee1230.jpg';
const AkiflowUrl = 'https://canny.io/case-studies/akiflow';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${AkiflowUrl}#webpage`,
    url: AkiflowUrl,
    name: 'Case Study: Akiflow × Canny',
    description: 'How Akiflow organized their feedback and started winning back churned customers.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${AkiflowUrl}#article`,
    genre: 'Case Study',
    headline: 'How Akiflow organized their feedback and started winning back churned customers',
    description:
      'Before Canny, Akiflow tracked feedback using Notion—creating a confusing mess. Their PM, Stefania Martinello, consolidated feedback into Canny, using Intercom integration and MRR-based prioritization. After launching the mobile app users requested, they notified churned customers via Canny and won many of them back. Plus, the built-in Slack integration keeps feedback channels active and visible.',
    inLanguage: 'en',
    url: AkiflowUrl,
    mainEntityOfPage: { '@id': `${AkiflowUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Akiflow', url: 'https://akiflow.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Akiflow', item: AkiflowUrl },
  ]),
]);

const AkiflowLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: AkiflowUrl },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}>
      <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
    </Helmet>
  );
};

export default AkiflowLandingHelmet;
